type Props = {
  src: string;
};

export default function FactionAvatar({ src }: Props) {
  const url = src || "./svg/faction/avatar.svg";

  return (
    <div className="size-14.5 p-0.5 border-[0.125rem] border-[#B8B8B8]/12 rounded-xl">
      <div
        className="size-full bg-white/3 bg-cover bg-no-repeat bg-center rounded-[0.3125rem]"
        style={{ backgroundImage: `url(${url})` }}
      />
    </div>
  );
}
